import { CustomAPIService } from 'drive-ui-packages';
import { DateTimeUnit } from 'luxon';

export const RDS_DATE_PICKER_SHOW_ONE_MONTH = 1;
export const RDS_DATE_PICKER_SHOW_TWO_MONTH = 2;
export const VIRTUAL_CARD = 'Virtual Card';
export const VIRTUAL_CARD_LANDING_PAGE = 'VIRTUAL_CARD';
export const CHECK = 'Check';
export const CHECK_LANDING_PAGE = 'CHECK';
export const AP_CHECK = 'Ap Check';
export const AP_CHECK_LANDING_PAGE = 'AP_CHECK';
export const CREDIT_CARD = 'CreditCard';
export const CHECK_CREDIT_CARD = 'CheckCreditCard';

export const AG_GRID_LICENSE =
  'Using_this_AG_Grid_Enterprise_key_( AG-045300 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( CDK Global, LLC )_is_granted_a_( Multiple Applications )_Developer_License_for_( 24 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 4 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 31 October 2024 )____[v2]_MTczMDMzMjgwMDAwMA==2785c7e6039d9f7ad5d800e0c401e3ee';

export const AG_GRID_AUTO_COL_ID = 'ag-Grid-AutoColumn';

export enum AgGridSortOptions {
  Ascending = 'asc',
  Descending = 'desc',
  None = ''
}

export const DEFAULT_LOCALE = 'en-US';

export const REDUX_SLICE_KEYS = {
  header: 'header',
  userData: 'userData',
  userStore: 'userStore',
  authorizeReview: 'authorizeReview',
  vendors: 'vendors',
  authorizePayment: 'authorizePayment',
  errorHandler: 'errorHandler',
  successHandler: 'successHandler',
  reconciliationReport: 'reconciliationReport',
  printChecks: 'printChecks',
  failedPrintChecks: 'failedPrintChecks',
  paymentDate: 'paymentDate',
  checkSequencing: 'checkSequencing'
};

export enum NodeEnvironments {
  Development = 'development'
}

export enum ReactEnvironments {
  Develop = 'develop',
  Local = 'local',
  PreProd = 'preprod'
}

export enum PaymentType {
  AccountsPayable = 'accountsPayable',
  OnDemand = 'onDemand',
  Register = 'register'
}

export enum Tabs {
  Schedule = 'schedule',
  ToBePaid = 'toBePaid',
  NeedsAuthorization = 'needsAuthorization',
  PrintChecks = 'printChecks',
  ReconcileCreditCards = 'reconcileCreditCards'
}

export const EVENT_NAME = {
  PrintChecks: 'Print Checks',
  PrintChecksSuccess: 'Print Checks Success',
  PrintChecksFailure: 'Print Checks Failure',
  AuthorizePayment: 'Authorize Payment',
  AuthorizePaymentSuccess: 'Authorize Payment Success',
  AuthorizePaymentFailure: 'Authorize Payment Failure',
  ToBePaidTab: 'To Be Paid tab',
  EnterAccountsPayable: 'Enter Accounts Payable',
  PrintChecksTab: 'Print Checks tab',
  RequestAuthorization: 'Request Authorization',
  ReviewAuthorization: 'Review Authorization',
  RetrySelected: 'Retry Selected',
  DeclinePayment: 'Decline Payment',
  CancelPayment: 'Cancel Payment',
  ReviewSelected: 'Review Selected',
  SelectVendorInvoices: 'Select Vendor Invoices',
  ReviewVendorSelections: 'Review Vendor Selections',
  SearchVendorInvoices: 'Search Vendor Invoices',
  SelectCreditCard: 'Select Credit Card',
  SelectCheckFilter: 'Select Check Filter',
  ExportCreditCardPayments: 'Export Credit Card Payments',
  OpenReconcileCreditCards: 'Open Reconcile Credit Cards',
  ReconcilePayments: 'Reconcile Payments',
  VoidVirtualCard: 'Void Virtual Card',
  SelectInvoiceDueDate: 'Select Invoice Due Date'
};

export const LOCALE = {
  EN: 'en'
};

export const TABLE_HEIGHT = '500px';

export enum ReconciliationStatus {
  Pending = 'Pending',
  Reconciled = 'Reconciled',
  Settled = 'Settled',
  Expired = 'Expired',
  Voided = 'Voided',
  PendingReconciled = 'PendingRenconciled'
}

export const ReconciliationReport = 'reconciliationReport';
export const ReconciliationDateFormatStatusUpdate = 'MM-dd-yyyy';
export enum DownloadFileName {
  AuthorizedPaymentFailedRecords = 'Authorized_Payment_Failed_Records.csv',
  AuthorizedPaymentCompletedRecords = 'Authorized_Payment_Completed_Records.csv',
  AuthorizedPaymentRecords = 'authorized_Payment_Records.csv'
}

export enum DownloadButton {
  SuccessFileDownload = 'SuccessFileDownload',
  FailedFileDownload = 'FailedFileDownload'
}

export enum PrintButton {
  SuccessFilePrint = 'SuccessFilePrint',
  FailedFilePrint = 'FailedFilePrint'
}

export const AUTHORITIES = {
  AUTHORIZE_AP_PAYMENTS: 'AUTHORIZE_AP_PAYMENTS',
  READ_ACCOUNTS_PAYABLE: 'READ_ACCOUNTS_PAYABLE',
  AUTHORIZE_DMS_AP_PAYMENTS: 'AUTHORIZE_DMS_AP_PAYMENTS',
  READ_DMS_ACCOUNTS_PAYABLE: 'READ_DMS_ACCOUNTS_PAYABLE',
  AUTHORIZE_APCHECK: 'AUTHORIZE_APCHECK',
  UPDATE_CHECK_NUMBER_AP_CHECK: 'UPDATE_CHECK_NUMBER_AP_CHECK',
  OVERRIDE_PRINTER_SETTINGS_AP_CHECK: 'OVERRIDE_PRINTER_SETTINGS_AP_CHECK'
};

export const ROLES = {
  UNAUTHORIZED: 'UNAUTHORIZED',
  AP_CLERK: 'AP_CLERK',
  AP_OFFICE_MANAGER: 'AP_OFFICE_MANAGER'
};

export enum ActiveAuthorizePaymentPage {
  AuthorizeReview = 'AuthorizeReview',
  AuthorizeResult = 'AuthorizeResult',
  ReviewChecks = 'ReviewChecks'
}

export const TOAST_POSITION = {
  FIXED: 'fixed'
};

export const TOAST_VARIANTS = {
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  NEUTRAL: 'neutral'
};

export const TWO_DECIMAL_POINTS = 2;

export const REACT_QUERY_OPTIONS = {
  RETRY: 0,
  REFETCH_ON_WINDOW_FOCUS: false,
  REFETCH_ON_MOUNT: false,
  REFETCH_ON_RECONNECT: true,
  STALE_TIME: 10000
};

export const DATE_TIME_UNITS: Record<string, DateTimeUnit> = {
  MONTH: 'month'
};

export const DATAFORMAT = {
  applicationPDF: 'application/pdf'
};
export const VENDOR_NAME = 'vendorName';

export const FLAGS = {
  printChecks: Tabs.PrintChecks
};

export const REACT_APP_AMPLITUDE_API_KEY: CustomAPIService = {
  develop: 'ea502d0f34d4ad0ec79a266692a4c2a5',
  master: 'e9ac10a7d3ec7e45e82a05a9aafad353'
};

export const HARNESS_SDK_IDENTIFIER: CustomAPIService = {
  develop: 'reactclientsdk',
  stage: 'reactclientsdk',
  perf: 'reactclientsdk',
  master: 'reactclientsdk'
};

export const HARNESS_SDK_NAME: CustomAPIService = {
  develop: 'dev-harness-client-sdk',
  stage: 'dev-harness-client-sdk',
  perf: 'dev-harness-client-sdk',
  master: 'dev-harness-client-sdk'
};

export const HARNESS_API_KEY: CustomAPIService = {
  develop: 'c1aaddc1-6b2f-49db-8e82-2d9e98339b5b',
  stage: '95c2daff-8faa-404b-8d2f-39a7d9be2692',
  perf: '8856eff8-b6c0-4358-822e-2c9af3b89b5d',
  master: 'd7a30ade-ae97-454b-8287-a4adb74ef6ea'
};

export const MAX_LEN = 255;

export enum FileType {
  XLS = 'xls',
  CSV = 'csv',
  PDF = 'pdf'
}

export const EXPORT_FILE_TYPES = ['xls', 'csv', 'pdf'] as const;

export type ExportFileType = typeof EXPORT_FILE_TYPES[number];

export const FILE_CONTENT_TYPE_MAP: Record<ExportFileType, string> = {
  csv: 'text/csv',
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel'
};

export const Z_INDEX_FOR_DIALOG = 50;
export const Z_INDEX_FOR_DROPDOWN = 60;
export const RIGHT_ALIGNED = 'rightAligned';
export const RIGHT_ALIGNED_STYLES = { 'justify-content': 'flex-end' };
export const TWO_HUNDRED = '200';
export const HTTP_STATUS_CODE = 'httpStatusCode';
export const SELECT = 'Select';
export const EXCEPTION = 'Exception:';
export const DEFAULT_PAGE_NO = 1;

export const CHECKS_ONLY = 'Use for these checks only';
